import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Header from './components/Header';                       // component for the app navigation
import ProtectedRoute from './components/ProtectedRoute';
import LanguageRoute from './components/LanguageRoute';         // filter snippets by language, redirect to home if the language is not supported
import Home from './pages/Home.js';             
import AddSnippet from './pages/AddSnippet.js';                 // page for adding snippets
import Login from './pages/Login.js';                           // page for the login form
import supportedLanguages from './data/supportedLanguages.js'
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/scss/main.scss'

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        // Check for token in localStorage on app load
        if (localStorage.getItem('token')) {
            setIsAuthenticated(true);
        }
    }, []);

    const handleLogin = () => {
        setIsAuthenticated(true);
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        setIsAuthenticated(false);
    };

    return (
        <Router>
            <>
                <Header onLogout={handleLogout} isAuthenticated={isAuthenticated} menuData={supportedLanguages}></Header>
                <Container fluid>
                    <Row className="mt-2 text-center">
                        <Col>
                            <h1>Knowledge base</h1>
                        </Col>
                    </Row>
                    <Routes>
                        {/* Home route for search and filtered snippets */}
                        <Route path="/" element={<Home />} />

                        {/* Dynamic route to filter by language */}
                        <Route path="/:language" element={<LanguageRoute supportedLanguages={supportedLanguages} />} />

                        {/* Protected route for adding a snippet */}
                        <Route 
                            path="/add-snippet" 
                            element={
                                <ProtectedRoute isAuthenticated={isAuthenticated}>
                                    <AddSnippet languageOptions={supportedLanguages} />
                                </ProtectedRoute>
                            } 
                        />

                        {/* Login route */}
                        <Route path="/login" element={<Login onLogin={handleLogin} />} />

                        {/* Catch-all route for undefined paths */}
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </Container>
            </>
        </Router>
  );
}

export default App;
